export default "__VITE_ASSET__BMH$QYM___"